/** @module Apparel/New3DEnvironment **/
import PostRequest from "csi/comm/PostRequest";
import html from "csi/html";
import locale from "csi/locale";
import { getFileNameExtension } from "csi/utility/fileUtility";
import sessionConstants from "csi/sessionConstants";
import New from "csi/table/New";
import declare from "dojo/_base/declare";

const New3DEnvironment = declare(New, {
	/** @property {boolean} bInterrupt - set to true so that controller is stopped on next action when user cancels file browser */
	bInterrupt: true,

	/** @property {File[]} fileSrcList - List of 3D Environment files to upload */
	fileSrcList: null,

	/**
	 * @override
	 * Validate selected file
	 */
	preProcess: function () {
		const validFile = this.fileSrcList.some((file) => getFileNameExtension(file.name) === "hdr");

		if (validFile) {
			this.inherited(arguments);
		} else {
			this.displayErrorDialog({ message: locale.resource("Error3DInvalidHdr") });
		}
	},

	/**
	 * @override
	 * Select files to upload.
	 */
	onPreActionDeferreds(dfds) {
		dfds.push(this.loadFileList());
	},

	loadFileList: async function () {
		// open select file dialog
		this.fileSrcList = await html.selectFiles(".hdr");
	},

	/**
	 * @override
	 * Publish request to create new 3D Environment
	 */
	process: function () {
		const req = new PostRequest("Apparel", "Create3DEnvironment")
			.addParameter("SessionURL", sessionConstants.sessionUrl)
			.addFiles(this.fileSrcList, null, "FormFileFieldName");

		this.waitForPublish(req.post(), true);
	},

	/**
	 * @override
	 * Get nodes resulting from action for postprocessing
	 */
	getNewNodes: function() {
		if (!this.m_response) {
			return this.inherited(arguments);
		}

		return this.m_response.getNodesOfType("ThreeDEnvironment");
	},
});

export = New3DEnvironment;
